import configState from '../state/config';
export var shouldReportSampling = function () {
    var _a, _b;
    var copyWritingConfig = ((_a = configState.config) !== null && _a !== void 0 ? _a : {}).copyWritingConfig;
    var sampleRatio = (_b = copyWritingConfig === null || copyWritingConfig === void 0 ? void 0 : copyWritingConfig.sampleRatio) !== null && _b !== void 0 ? _b : 0.1;
    var formatSamplingRate = Number(sampleRatio);
    if (isNaN(formatSamplingRate) ||
        formatSamplingRate < 0 ||
        formatSamplingRate > 1)
        return false;
    return Math.random() < formatSamplingRate;
};
